import { useContext } from 'react';
import { Handle, Position } from 'reactflow';
import { useProcessStore } from '../../../store/process-store/process-store.hooks';
import { skyDark } from '../../../styles/design-tokens';
import { ProcessContext } from '../../process/context/process.context';
import { resetProcessTaskDetails } from '../process-graph/process-graph.helpers';
import { EdgeLabel } from './event-edge';

type EdgeLabelNodeProps = {
  data: {
    cost: number;
    cycle_time: number;
    dashed: boolean;
    isRightGraph: boolean;
    percentage: number;
    task_count: number;
    viewType: string;
    weight: number;
    edgeId: string;
  };
};

export const EdgeLabelNode = ({ data }: EdgeLabelNodeProps) => {
  const processContext = useContext(ProcessContext);
  const processStore = useProcessStore();
  const { eventScope, setEventScope, rightEventScope, setRightEventScope } = processStore;

  const handleClick = () => {
    resetProcessTaskDetails(processContext, processStore);

    if (data.isRightGraph) {
      setRightEventScope({
        ...rightEventScope,
        selectedEdgeId: data.edgeId,
      });
      setEventScope({
        ...eventScope,
        selectedEdgeId: null,
      });
    } else {
      setEventScope({
        ...eventScope,
        selectedEdgeId: data.edgeId,
      });
      setRightEventScope({
        ...rightEventScope,
        selectedEdgeId: null,
      });
    }
  };
  return (
    <div onClick={handleClick}>
      <Handle type="target" position={Position.Bottom} />
      <EdgeLabel edgeId={data.edgeId} data={data} color={skyDark} />
      <Handle type="source" position={Position.Top} />
    </div>
  );
};
